import { PLAN_FEATURES, ALL_FEATURES } from "@/types";

// Resolves enabled feature flags for a tenant: plan defaults + per-tenant overrides.
// Super Admin sees everything. Mirrors backend app/domain/feature_flags.py.
export function enabledFeatures(tenant, isSuperAdmin = false) {
  if (isSuperAdmin) return new Set(ALL_FEATURES);
  const plan = tenant?.plan || "starter";
  const set = new Set(PLAN_FEATURES[plan] || []);
  const overrides = tenant?.features || {};
  Object.entries(overrides).forEach(([key, on]) => (on ? set.add(key) : set.delete(key)));
  return set;
}

export function isFeatureEnabled(flags, flag) {
  if (!flag) return true;
  return flags.has(flag);
}
